import React from 'react';
import { PodPlansGrid } from './PodPlansGrid';
import type { AiPod } from '../../../../services/aiPodService';
import { Button } from '../../../../components/ui/Button';
import { Overlay } from '../../../../components/ui/Overlay';

type Props = {
  pod: AiPod;
  onClose: () => void;
};

export const PodPlansModal: React.FC<Props> = ({ pod, onClose }) => {
  return (
    <Overlay tone="dim-40" className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="flex w-full max-w-4xl flex-col rounded-2xl bg-white shadow-xl max-h-[90vh]">
        {/* Header */}
        <div className="flex shrink-0 items-center justify-between border-b border-agentic-gray-100 px-6 py-4">
          <div>
            <h2 className="text-base font-semibold text-agentic-text-primary">{pod.name}</h2>
            <p className="text-xs text-agentic-text-secondary font-mono">{pod.code}</p>
          </div>
          <Button tone="custom"
            onClick={onClose}
            className="rounded-lg p-1.5 text-agentic-text-secondary hover:bg-agentic-gray-100 transition"
            aria-label="Close"
          >
            <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </Button>
        </div>

        {/* Plans content */}
        <div className="overflow-y-auto">
          <PodPlansGrid aiPodId={pod.id} />
        </div>
      </div>
    </Overlay>
  );
};
